<div class="gallery-container page-container">
  <div *ngIf="isLoaderVisible">
    <app-loader></app-loader>
  </div>


  <mat-tab-group mat-stretch-tabs="true" dynamicHeight (selectedTabChange)="changeCategory($event)" [(selectedIndex)]="tabIndex">
    <mat-tab label="{{'galleryCanvasPaintings'|translate}}">
      <div class="tab-content">
        <div class="seo-descr">
          {{'canvasCategoryShortDescription' | translate}}
        </div>
        <div class="availability-switch-wrapper">
          <label class="switch">
            <input
              type="checkbox"
              [checked]="isJustAvailableVisible"
              (change)="toggleAvailable()"
            />
            <span class="slider round"></span>
          </label>
          <span style="margin-left: 5px;">{{'seeJustAvailable' | translate}}</span>
        </div>
        <div class="paintings-wrapper">
          <div *ngFor="let painting of paintings" class="img-container lazy-load hidden" #lazyElement [routerLink]="['/Painting', painting.category, painting.id]">
            <div class="image-wrapper">
              <span *ngIf="!painting.availability" class="availability-label">{{'available' | translate}}</span>
              <img [src]="painting.path" alt="pictura pe panza">
            </div>
            <button mat-button class="transparent-button">{{'seeDetails' | translate}}</button>
          </div>
          <div *ngIf="paintings.length == 0 && isDataReady" class="seo-descr">
            {{'noResultsFound' | translate}}
          </div>
        </div>
        <div class="seo-descr">
          {{'canvasCategoryLongDescription' | translate}}
        </div>
      </div>
    </mat-tab>
    <mat-tab label="{{'galleryWallPaintings'|translate}}">
      <div class="tab-content">
        <div class="seo-descr">
          {{'wallCategoryShortDescription' | translate}}
        </div>
        <div class="availability-switch-wrapper">
          <label class="switch">
            <input
              type="checkbox"
              [checked]="isJustAvailableVisible"
              (change)="toggleAvailable()"
            />
            <span class="slider round"></span>
          </label>
          <span style="margin-left: 5px;">{{'seeJustAvailable' | translate}}</span>
        </div>
        <div class="paintings-wrapper">
          <div *ngFor="let painting of paintings" class="img-container lazy-load hidden" #lazyElement [routerLink]="['/Painting', painting.category, painting.id]">
            <div class="image-wrapper">
              <span *ngIf="!painting.availability" class="availability-label">{{'available' | translate}}</span>
              <img [src]="painting.path" alt="pictura pe perete">
            </div>
            <button mat-button class="transparent-button">{{'seeDetails' | translate}}</button>
          </div>
          <div *ngIf="paintings.length == 0 && isDataReady" class="seo-descr">
            {{'noResultsFound' | translate}}
          </div>
        </div>
        <div class="seo-descr">
          {{'wallCategoryLongDescription' | translate}}
        </div>
      </div>
    </mat-tab>
    <mat-tab label="{{'gallerySpecialGifts'|translate}}">
      <div class="tab-content">
        <div class="seo-descr">
          {{'specialCategoryShortDescription' | translate}}
        </div>
        <div class="availability-switch-wrapper">
          <label class="switch">
            <input
              type="checkbox"
              [checked]="isJustAvailableVisible"
              (change)="toggleAvailable()"
            />
            <span class="slider round"></span>
          </label>
          <span style="margin-left: 5px;">{{'seeJustAvailable' | translate}}</span>
        </div>
        <div class="paintings-wrapper">
          <div *ngFor="let painting of paintings" class="img-container lazy-load hidden" #lazyElement [routerLink]="['/Painting', painting.category, painting.id]">
            <div class="image-wrapper">
              <span *ngIf="!painting.availability" class="availability-label">{{'available' | translate}}</span>
              <img [src]="painting.path" alt="cadouri speciale">
            </div>
            <button mat-button class="transparent-button">{{'seeDetails' | translate}}</button>
          </div>
          <div *ngIf="paintings.length == 0 && isDataReady" class="seo-descr">
            {{'noResultsFound' | translate}}
          </div>
        </div>
        <div class="seo-descr">
          {{'specialCategoryLongDescription' | translate}}
        </div>
      </div>
    </mat-tab>
    <mat-tab label="{{'namePicture127'|translate}}">
      <div class="tab-content">
        <div class="seo-descr">
          {{'martisoareCategoryShortDescription' | translate}}
        </div>
        <div class="availability-switch-wrapper">
          <label class="switch">
            <input
              type="checkbox"
              [checked]="isJustAvailableVisible"
              (change)="toggleAvailable()"
            />
            <span class="slider round"></span>
          </label>
          <span style="margin-left: 5px;">{{'seeJustAvailable' | translate}}</span>
        </div>
        <div class="paintings-wrapper">
          <div *ngFor="let painting of paintings" class="img-container lazy-load hidden" #lazyElement [routerLink]="['/Painting', painting.category, painting.id]">
            <div class="image-wrapper">
              <span *ngIf="!painting.availability" class="availability-label">{{'available' | translate}}</span>
              <img [src]="painting.path" alt="martisoare">
            </div>
            <button mat-button class="transparent-button">{{'seeDetails' | translate}}</button>
          </div>
          <div *ngIf="paintings.length == 0 && isDataReady" class="seo-descr">
            {{'noResultsFound' | translate}}
          </div>
        </div>
        <div class="seo-descr">
          {{'martisoareCategoryLongDescription' | translate}}
        </div>
      </div>
    </mat-tab>
    <mat-tab label="{{'galleryChristmas'|translate}}">
      <div class="tab-content">
        <div class="seo-descr">
          {{'christmasCategoryShortDescription' | translate}}
        </div>
        <div class="availability-switch-wrapper">
          <label class="switch">
            <input
              type="checkbox"
              [checked]="isJustAvailableVisible"
              (change)="toggleAvailable()"
            />
            <span class="slider round"></span>
          </label>
          <span style="margin-left: 5px;">{{'seeJustAvailable' | translate}}</span>
        </div>
        <div class="paintings-wrapper">
          <div *ngFor="let painting of paintings" class="img-container lazy-load hidden" #lazyElement [routerLink]="['/Painting', painting.category, painting.id]">
            <div class="image-wrapper">
              <span *ngIf="!painting.availability" class="availability-label">{{'available' | translate}}</span>
              <img [src]="painting.path" alt="craciun">
            </div>
            <button mat-button class="transparent-button">{{'seeDetails' | translate}}</button>
          </div>
          <div *ngIf="paintings.length == 0 && isDataReady" class="seo-descr">
            {{'noResultsFound' | translate}}
          </div>
        </div>
        <div class="seo-descr">
          {{'christmasCategoryLongDescription' | translate}}
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
